import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from 'pages/layout';
import { Suspense, lazy } from 'react';
import {
  AuthenticateRoutes,
  UnAuthenticateRoutes
} from 'pages/layout/PrivateRoute';
import { useSelector } from 'react-redux';
import { superAdminValidation, appAccountValidation } from 'utilities/authTokenValidation';

const Loadable = (Component: any) => (props: JSX.IntrinsicAttributes) => (
  <Suspense>
    <Component {...props} />
  </Suspense>
);

const Login = Loadable(lazy(() => import('pages/authentication/Login')));
const Dashboard = Loadable(lazy(() => import('pages/modules/dashboard')));
const Moderate = Loadable(lazy(() => import('pages/modules/moderate')));
const CMS = Loadable(lazy(() => import('pages/modules/cms')));
const SendInvite = Loadable(lazy(() => import('pages/modules/sendInivite')));
const Broadcast = Loadable(lazy(() => import('pages/modules/broadcast')));
const AccountSettings = Loadable(
  lazy(() => import('pages/modules/accountSettings'))
);
const DeletedUsers = Loadable(lazy(() => import('pages/modules/deletedUsers')));

const Routers = () => {
  const authToken = useSelector((state: any) => state.userAuth?.authToken);
  const isSuperAdmin = superAdminValidation?.(authToken ?? null);
  const isAppAccount = appAccountValidation?.(authToken ?? null);

  return (
  <>
    <Routes>
      <Route element={<UnAuthenticateRoutes />}>
        <Route path='/' element={<Login />} />
      </Route>
      <Route element={<AuthenticateRoutes />}>
        <Route element={<Layout />}>
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/moderate' element={<Moderate />} />
          <Route path='/cms' element={<CMS />} />
          <Route path='/sendInvite' element={<SendInvite />} />
          <Route
            path='/broadcast'
            element={
              isSuperAdmin
                ? <Navigate to="/dashboard" replace />
                : <Broadcast />
            }
          />
          <Route path='/broadcast' element={<Broadcast />} />
          <Route path='/accountSettings' element={<AccountSettings />} />
          <Route
            path='/deletedUsers'
            element={isAppAccount ? <DeletedUsers /> : <Navigate to="/dashboard" replace />}
          />
        </Route>
      </Route>
    </Routes>
  </>
  );
};

export default Routers;
